export type EquipmentType =
  | 'BULK'
  | 'CHASSIS'
  | 'CONTAINER'
  | 'FLAT'
  | 'GENSET'
  | 'REEFER'
  | 'TANK'
  | 'OTHER'
  | 'UNKNOWN';

export const getTypeFromIso = (iso: string = ''): EquipmentType => {
  const matches = iso.match(/\d\d([A-Z][A-Z])/);
  const type: string | undefined = matches?.[1];
  if (!type) return 'UNKNOWN';
  switch (type[0]) {
    case 'B':
      return 'BULK';
    case 'G':
    case 'S':
    case 'U':
    case 'V':
      return 'CONTAINER';
    case 'P':
      return 'FLAT';
    case 'H':
    case 'R':
      return 'REEFER';
    case 'T':
      return 'TANK';
    default:
      return 'OTHER';
  }
};

export const getSizeFromIso = (iso: string = ''): number | undefined => {
  switch (iso[0]) {
    case '1':
      return 10;
    case '2':
      return 20;
    case '3':
      return 30;
    case '4':
      return 40;
    case 'B':
      return 24;
    case 'C':
      return 24.5;
    case 'G':
      return 41;
    case 'H':
      return 43;
    case 'L':
      return 45;
    case 'M':
      return 48;
    case 'N':
      return 49;
    default:
      return undefined;
  }
};

export const getIsoDisplay = ([firstSt, ...restSt]: string[]) => [firstSt, ...restSt.map(st => st.substring(2))].join('/');

export const isoDescriptions = {
  '20GP': 'GENERAL PURPOSE CONT.',
  '20HR': 'ISOLADO CONTAINE REEFER - INSULATED CONTAINER',
  '20PF': 'FLAT (FIXED ENDS)',
  '20TD': 'TANK CONTAINER',
  '20TG': 'TANK CONTAINER',
  '20TN': 'TANK CONTAINER',
  '22BU': 'BULK CONTAINER',
  '22GP': 'GENERAL PURPOSE CONT.',
  '22HR': 'INSULATED CONTAINER',
  '22PC': 'FLAT (COLLAPSIBLE)',
  '22PF': 'FLAT (FIXED ENDS)',
  '22RC': 'REEFER CONT.(NO FOOD)',
  '22RS': 'BUILT-IN GEN. F. POWER SPLY OF REEF',
  '22RT': 'REEFER CONTAINER',
  '22SN': 'NAMED CARGO CONTAINER',
  '22TD': 'TANK CONTAINER',
  '22TG': 'TANK CONTAINER',
  '22TN': 'TANK CONTAINER',
  '22UP': 'HARDTOP CONTAINER',
  '22UT': 'OPEN TOP CONTAINER',
  '22VH': 'VENTILATED CONTAINER',
  '25GP': 'GP-CONTAINER HIGH CUBE',
  '26GP': 'GP-CONTAINER SUPER HIGH CUBE',
  '26HR': 'INSULATED CONTAINER',
  '28TG': 'TANK FOR GAS',
  '28UT': 'OPEN TOP (HALF HEIGHT)',
  '28VH': 'VE-HALF-HEIGHT =1448 MM HEIGHT',
  '29PL': 'PLATFORM',
  '2EGP': 'GEN. PURP. WITHOUT VENT WIDTH 2.5M',
  '42GP': 'GENERAL PURPOSE CONT.',
  '42HR': 'INSULATED CONTAINER',
  '42PC': 'FLAT (COLLAPSIBLE)',
  '42PF': 'FLAT (FIXED ENDS)',
  '42PS': 'FLAT (SPACE SAVER)',
  '42RC': 'REEFER CONT.(NO FOOD)',
  '42RS': 'REEFER CONT.(DIESEL GEN.)',
  '42RT': 'REEFER CONTAINER',
  '42SN': 'NAMED CARGO CONTAINER',
  '42TD': 'TANK CONTAINER',
  '42TG': 'TANK CONTAINER',
  '42TN': 'TANK CONTAINER',
  '42UP': 'HARDTOP CONTAINER',
  '42UT': 'OPEN TOP CONTAINER',
  '45BK': 'BULK CONTAINER',
  '45GP': 'HIGH CUBE CONT.',
  '45PC': 'FLAT (COLLAPSIBLE)',
  '45RC': 'REEFER CONT.(NO FOOD)',
  '45RT': 'REEFER HIGHCUBE CONTAINER',
  '45UT': 'OPEN TOP CONTAINER',
  '45UP': 'HIGH CUBE HARDTOP CONT.',
  '46HR': 'INSULATED CONTAINER',
  '48TG': 'TANK FOR GAS',
  '49PL': 'PLATFORM',
  '4CGP': 'GP CONTAINER',
  'L0GP': 'LOW CUBE CONT.',
  'L2GP': 'STANDARD CONT.',
  'L5GP': 'HIGH CUBE CONT.'
};
